// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"Fp","modify_order":"Gp","modify_order_header":"Hp","product_details_form_wrapper":"Ip","c_wrapper":"Jp","save_button":"Kp","title":"Lp","modify_order_title_wrapper":"Mp","note":"Np","buttons_wrapper":"Op"};
    if(module.hot) {
      // 1714422952767
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  